import { httpGet } from "../services/apiService";
import Fuse from "fuse.js"

export const isocinduModule = {
    state: () => ({
        fetchingIsocindu: false,
        errorFetchingIsocindu: false,
        allIsocindu: [],
        selectedIsocindu: [],
        fuseIsocindu: [],
        totalIsocindu: 0,
        totalPesoIsocindu: 0,
    }),
    mutations: {
        setFetchingIsocindu(state, newValue) {
            state.fetchingIsocindu = newValue;
        },
        setErrorFetchingIsocindu(state, newValue) {
            state.errorFetchingIsocindu = newValue;
        },
        setAllIsocindu(state, newValue) {
            state.allIsocindu = newValue;
        },
        setSelectedIsocindu(state, newValue) {
            state.selectedIsocindu = newValue;
        },
        setFuseIsocindu(state, newValue) {
            state.fuseIsocindu = newValue;
        },
        setTotalIsocindu(state, newValue) {
            state.totalIsocindu = newValue;
        },
        setTotalPesoIsocindu(state, newValue) {
            state.totalPesoIsocindu = newValue;
        },
    },
    actions: {
        async getIsocindu({ state, commit }) {
            const { data } = await httpGet("/productos?filters[familia][$eq]=panel_isocindu&populate=grosores");
            ("Panel Isocindu", data?.data);
            commit("setAllIsocindu", data?.data);
            commit("setFuseIsocindu", new Fuse([...state.allIsocindu], {
                keys: ["attributes.codigo", "attributes.descripcion"],
            }));
        },
        addIsocindu({ state, rootState, commit }, newValue) {
            // Flatten product object
            let newEntry = {
                ...newValue.attributes,
                id: newValue.id,
                cantidad: 1,
                largo: 1,
            };

            // Set unit options.
            let unitOptions = [];
            for (const f in newEntry.factores) {
                if (Object.hasOwnProperty.call(newEntry.factores, f)) {
                    const element = newEntry.factores[f];
                    unitOptions.push({ text: element.referencia, value: element });
                }
            }

            newEntry.unit_options = unitOptions.filter(u => u.value.activo == true);
            newEntry.selected_unit = newEntry.unit_options[0].value ?? null;

            // Set discounts
            newEntry.minDiscount = 0;
            newEntry.maxDiscount = 100;
            if (rootState.client?.selectedClient == null) {
                newEntry.descuento_seleccionado = 0;
            }
            else {
                newEntry.descuento_seleccionado = rootState?.client?.selectedClient?.attributes?.descuento_isocindu ?? 0;
            }

            let thickness_options = [];
            for (const g of newEntry?.grosores?.data) {
                const option = { text: g.referencia, value: { id: g.id, ...g.attributes } };
                thickness_options.push(option);
            }

            newEntry.thickness_options = thickness_options;
            newEntry.grosor_seleccionado = newEntry.thickness_options[0].value ?? null;

            const valorFlete = 1;

            // Set calculated price fields.
            newEntry.precio_provicional_uno = newEntry.precio_lista / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_provicional_dos = newEntry.precio_provicional_uno * (1 - newEntry.descuento_seleccionado / 100)
            newEntry.flete_provicional = (valorFlete * newEntry.factores.kilogramo.valor) / newEntry.factores.metro_cuadrado.valor;
            newEntry.precio_unitario_final = (newEntry.precio_provicional_dos + newEntry.flete_provicional) * newEntry.largo;
            newEntry.total_local = newEntry.precio_unitario_final * newEntry.cantidad;

            // Set calculated weight fields.
            newEntry.peso_calculado = newEntry.cantidad * (newEntry.selected_unit.peso_por_unidad ?? 0) * newEntry.largo;

            if (newEntry.selected_unit.peso_por_unidad == null) {
                commit("setWarningsPeso", [...rootState.warningsPeso, newEntry]);
            }

            ("new isocindu", newEntry);
            commit("setSelectedIsocindu", [...state.selectedIsocindu, newEntry]);
        },
        updateIsocindu({ state, rootState, commit }, item) {
            const valorFlete = 1;

            if (item.descuento_seleccionado >= item.maxDiscount) {
                item.descuento_seleccionado = item.maxDiscount;
            }
            if (item.descuento_seleccionado <= item.minDiscount) {
                item.descuento_seleccionado = 0;
            }

            // Set calculated price fields.
            item.precio_provicional_uno = item.precio_lista / item.factores.metro_cuadrado.valor;
            item.precio_provicional_dos = item.precio_provicional_uno * (1 - item.descuento_seleccionado / 100)
            item.flete_provicional = (valorFlete * item.factores.kilogramo.valor) / item.factores.metro_cuadrado.valor;
            item.precio_unitario_final = (item.precio_provicional_dos + item.flete_provicional) * item.largo;
            item.total_local = item.precio_unitario_final * item.cantidad;

            // Set calculated weight fields.
            item.peso_calculado = item.cantidad * (item.selected_unit.peso_por_unidad ?? 0) * item.largo;

            commit('setSelectedIsocindu', [...state.selectedIsocindu]);
        },
        deleteIsocindu({ state, rootState, commit, dispatch }, product) {
            commit("setSelectedIsocindu", state.selectedIsocindu.filter(p => p.id != product.id));
            commit("setWarningsPeso", rootState.warningsPeso.filter(p => p.id != product.id));
        },
        updateAllByDestiny({ state, dispatch }) {
            for (const item of state.selectedIsocindu) {
                dispatch("updateIsocindu", item);
            }

            dispatch("updateQuotationTotals");
        }
    }
}